function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7922 17.3291C10.7922 18.3216 10.2631 19.0812 9.40375 19.5777C8.54469 20.0739 7.48616 20.0739 6.6287 19.5777C5.7691 19.0812 5.24023 18.3216 5.24023 17.3291",
  fill: "#D3D2D2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.01529 0C8.77249 0 9.38237 0.466832 9.38237 1.18473C9.38237 1.63658 9.39814 1.97374 9.68209 2.0601C12.0967 2.78923 13.6451 4.49827 13.6451 6.71772V10.4481C13.6451 12.1571 14.3443 12.5031 15.2242 13.1568C16.4985 14.102 16.2076 16.0701 14.7453 16.0688H1.2858C-0.176455 16.0701 -0.467355 14.102 0.806941 13.1568C1.68579 12.5031 2.38604 12.1571 2.38604 10.4481V6.71772C2.38604 4.49827 3.93439 2.78923 6.34903 2.0601C6.63218 1.97374 6.64875 1.63658 6.64875 1.18473C6.64902 0.466832 7.25916 0 8.01529 0V0Z",
  fill: "#D3D2D2"
});

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9510113289bb2ac9d20ffe7004e71dd3.svg";
export { ForwardRef as ReactComponent };